import React from "react";
import BanAutoCompleteResult from "./BanAutoCompletResult";
import "isomorphic-fetch";
import { connect } from "react-redux";
import { coordinates } from "ol/geom/flat/reverse";
import FloatingInputLabel from "./FloatingInputLabel";

class BanAutoComplete extends React.Component {
    constructor(props) {
        super(props);
        this.state = { query: "", results: [] };
        this.handleChange = this.handleChange.bind(this);
        this.getResults = this.getResults.bind(this);
        this.selectResult = this.selectResult.bind(this);
    }

    getResults() {
        const query = this.state.query;
        const maxResults = this.props.maxResults || 100;
        const minCharacters = this.props.minCharacters || 3;
        if (query.length < minCharacters) return;
        const banRequest = new Request(
            "https://api-adresse.data.gouv.fr/search/?q=" +
                query +
                "&limit=" +
                maxResults +
                ""
        );
        //banRequest.mode = "no-cors";
        fetch(banRequest)
            .then((response) => {
                return response.json();
            })
            .then((json) => {
                this.setState({
                    results: json.features.filter(
                        (i) =>
                            i.properties.citycode.contain("2B") ||
                            i.properties.citycode.contain("2A")
                    ), // filter only in corse !!!!
                    query: this.state.query,
                });
            });
    }

    handleChange(event) {
        this.setState({ query: event.target.value });
    }

    selectResult(id) {
        const getById = (item) => {
            return item.properties.id === id;
        };
        const currentResult = this.state.results.filter(getById)[0];
        const currentAddressTemplated = this.templateQuery(currentResult);
        this.setState({ results: [], query: currentAddressTemplated });

        this.props.updateCenter(currentResult.geometry.coordinates);
    }

    templateQuery(address) {
        return address.properties.name + " " + address.properties.context;
    }

    render() {
        return (
            <div
                className={
                    "d-flex flex-column flex-md-row align-items-md-center w-100"
                }
            >
                <div className="form-group mb-3 mb-md-0 w-100">
                    {/* <input
                        className="form-control filter-tools-input w-100 mt-3"
                        type="text"
                        placeholder={"Votre adresse"}
                        style={{
                            minWidth: "348px",
                            minHeight: "35px",
                            display: "block",
                            textAlign: "center",
                        }}
                        value={this.state.query}
                        onChange={this.handleChange}
                        onKeyUp={this.getResults}
                    /> */}
                    <FloatingInputLabel
                        label={"Votre adresse"}
                        className={"input-adresse"}
                        value={this.state.query}
                        onChange={this.handleChange}
                        KeyUp={this.getResults}
                    />
                    <BanAutoCompleteResult
                        results={this.state.results}
                        selectResult={this.selectResult}
                    />
                    <button
                        type="submit"
                        className="btn btn-sm btn-block mb-3 mb-md-0 w-100"
                        style={{
                            backgroundColor: "#3FB9AA",
                            color: "#FFFFFF",
                            fontSize: "12px",
                            fontWeight: "700",
                            border: "none",
                            borderRadius: "4px",
                            height: "35px",
                            display: "block",
                            marginTop: "10px",
                        }}
                    >
                        VALIDER
                    </button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        entityCodeTerr: state.MeReducer.entity.codes_terr,
    };
};

const mapDispatchTProps = (dispatch) => {
    return {
        updateCenter: (e) =>
            dispatch({ type: "UPDATE_CENTER_MAP", data: { centerMap: e } }),
    };
};

export default connect(mapStateToProps, mapDispatchTProps)(BanAutoComplete);
